import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/specialstudent/applications', config);
}

const exportExcel = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    config = { ...config, responseType: 'blob' };
    return Api.get('/specialstudent/applications/excel-export', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/specialstudent/applications/${id}`);
}

const evaluate = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/specialstudent/applications/${id}/evaluate`, data);
}

const downloadForm = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/specialstudent/applications/${id}/download-form`, { responseType: 'blob' });
}

const deleteApplication = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/specialstudent/applications/${id}`);
}
const evaluateDocument = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/specialstudent/applications/${id}/evaluate-document`, data);
}
const evaluateCourse = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/specialstudent/applications/${id}/evaluate-course`, data);
}
export default {
    getAll,
    exportExcel,
    get,
    evaluate,
    downloadForm,
    deleteApplication,
    evaluateDocument,
    evaluateCourse
}
